import { render, staticRenderFns } from "./VaccinationAdmin.vue?vue&type=template&id=08fcaa08&"
import script from "./VaccinationAdmin.vue?vue&type=script&lang=js&"
export * from "./VaccinationAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports